<div class="box-shadow module" style="width:80%; margin:auto; margin-bottom:20px">
  <h2>{{'Edit Task Plan'|translate}}</h2>

  <div class="form-horizontal">
    <div class="form-group">
      <label class="control-label col-md-2">{{'Business Unit'|translate}}</label>
      <div class="col-md-10">

        <select [appBUSwitcher]="selectedBU" class="form-control" (ngModelChange)="onSelectBusinessUnit($event)"
          [(ngModel)]="taskPlan.BusinessUnitId">
          <option *ngFor="let bu of lstBusinessUnit" [ngValue]="bu.Id">
            {{ bu.Name }}
          </option>
        </select>
        <span class="text-danger field-validation-error" *ngIf="displayWarningBusinessUnit">
          <span>{{'The Business Unit field is required'|translate}}.</span>
        </span>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label col-md-2">{{'Description'|translate}}</label>
      <div class="col-md-10">
        <input class="form-control text-box single-line" [(ngModel)]="taskPlan.Description">
        <span class="text-danger field-validation-error" *ngIf="displayWarningDesc">
          <span>{{'The Task Plan field is required'|translate}}.</span>
        </span>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-md-2">{{'Hide Code'|translate}}</label>
      <div class="col-md-10">
        <input type="checkbox" [(ngModel)]="taskPlan.HideCode" value="taskPlan.HideCode">
      </div>
    </div>

    <app-toggle-rich-input [displayRichEditor]="hasRichText(taskPlan.DefaultWalkthroughSignatureDisclaimer)"
      [label]="'DefaultWalkdownSignatureDisclaimer' | translate"
      [(ngModel)]="taskPlan.DefaultWalkthroughSignatureDisclaimer">
    </app-toggle-rich-input>

    <app-toggle-rich-input [displayRichEditor]="hasRichText(taskPlan.DefaultSummarySignatureDisclaimer)"
      [label]="'DefaultSummarySignatureDisclaimer' | translate"
      [(ngModel)]="taskPlan.DefaultSummarySignatureDisclaimer">
    </app-toggle-rich-input>

    <div class="form-group">
      <div class="col-md-offset-2 col-md-10">
        <a class="btn btn-default" style="width: 100px;" (click)="updateTaskPlan()">{{'Save'|translate}}</a>
      </div>
    </div>
  </div>
</div>

<div style="width:80%; margin:auto">
  <a (click)="onRedirectButtonClick()" style="cursor: pointer;">{{'Back to Task Plan'|translate}}</a>
</div>
